import fidget from "../../images/circleIcons/fidget.png";
import FruitRollUp from "../../images/circleIcons/FruitRollUp.png";
import Frames from "../../images/circleIcons/Frames.png";
import Tea from "../../images/circleIcons/Tea.png";
import Umbrella from "../../images/circleIcons/Umbrella.png";
import Diapers from "../../images/circleIcons/Diapers.png";
import Hulu from "../../images/circleIcons/Hulu.png";
import Rice from "../../images/circleIcons/Rice.png";
import Tuna from "../../images/circleIcons/Tuna.png";
import Washing from "../../images/circleIcons/Washing.png";


const questionAnswers = [
  {
    title: "DEMAND CURVE FOR FIDGET SPINNERS",
    question: "Mass production makes fidget spinners cheaper to produce.",
    subQuestion: "Consider the demand curve for fidget spinners. What happens?",
    icon: fidget,
    answer: "goes up",
    graphType: "demand curve",
    briefness:
      "Only the price has changed. As the price decreases, the quantity demanded of fidget spinners increases.",
  },
  {
    title: "DEMAND CURVE FOR FRUIT ROLL-UPS",
    question: 'Social media users rave about combining fruit roll-ups and ice cream.',
    subQuestion: "Consider the demand for fruit roll-ups.",
    icon: FruitRollUp,
    answer: "shifts right",
    graphType: "demand curve",
    briefness: "Consumers are likely to increase their demand for fruit roll-ups as they see the trend all over social media. Demand for fruit roll-ups will increase and the demand curve will shift to the right.",
  },
  {
    title: "DEMAND CURVE FOR PICTURE FRAMES",
    question: "Pet psychics gain popularity with pet owners. What happens to demand for picture frames?",
    subQuestion: "Consider the demand for picture frames. What happens?",
    icon: Frames,
    answer: "Nothing happens",
    graphType: "demand curve",
    briefness:
      "This was a trick question. The demand curve for picture frames is unrelated to the demand for pet psychics.",
  },
  {
    title: "DEMAND CURVE FOR TEA",
    question: "The British Crown announces a 3 penny tax on all tea sold in the 13 colonies.",
    subQuestion: "Consider the demand curve for tea in the 13 colonies. What happens?",
    icon: Tea,
    answer:  "goes down",
    graphType: "demand curve",
    briefness:
      "Only the price has changed. As the price increases, the quantity demanded decreases.",
  },
  {
    title: "DEMAND CURVE FOR UMBRELLAS",
    question: "Weather forecasters predict increasingly wet weather for this fall and winter.",
    subQuestion: "Consider the demand for umbrellas. What happens?",
    icon: Umbrella,
    answer: "shifts right",
    graphType: "demand curve",
    briefness:
      "If consumers expect more wet weather, they will increase their demand for wet weather goods including umbrellas. Demand for umbrellas increases and the demand curve shifts right.",
  },
  {
    title: "DEMAND CURVE FOR INFANT DIAPERS",
    question: "Birth rates decrease dramatically.",
    subQuestion: "Consider the demand for infant diapers. What happens?",
    icon: Diapers,
    answer: "shifts left",
    graphType: "demand curve",
    briefness:
      "A decreasing infant population will decrease the demand for infant diapers and the demand curve will shift left. ",
  },
  {
    title: "DEMAND CURVE FOR HULU",
    question: "Netflix raises the price of a monthly subscription.",
    subQuestion: "Consider the demand for Hulu. What happens?",
    icon: Hulu,
    answer: "shifts right",
    graphType: "demand curve",
    briefness:
      "Netflix and Hulu are substitutes. When Netflix raises subscription prices, some consumers will look for alternatives, such as Hulu. Demand for Hulu increases and the demand curve shifts right.",
  },
  {
    title: "DEMAND CURVE FOR RICE IN THE PHILIPPINES",
    question: "The Phillipine government announces a price cap on rice. The price cap is below the current market price.",
    subQuestion: "Consider the demand for rice in the Philippines. What happens?",
    icon: Rice,
    answer: "goes up",
    graphType: "demand curve",
    briefness:
      "Only the price of rice has changed. When the price of rice decreases, the quantity demanded increases.",
  },
  {
    title: "DEMAND FOR CANNED TUNA",
    question: "Canned tuna executives conspire to raise the price of canned tuna.",
    subQuestion: "Consider the demand for canned tuna. What happens?",
    icon: Tuna,
    answer: "goes down",
    graphType: "demand curve",
    briefness:
      "Only the price of canned tuna has changed. At a higher price, the quantity demanded decreases.",
  },
  {
    title: "DEMAND FOR WASHING MACHINES",
    question: "Trade groups report that a tariff on washing machines is likely to be removed in the next few months, which would lower the price of washing machines significantly.",
    subQuestion: "Consider the current demand curve for washing machines. What happens?",
    icon: Washing,
    answer: "shifts left",
    graphType: "demand curve",
    briefness: "Consumers expect that the price of washing machines is likely to decrease in the future. Consumers are likely to hold off on current purchases. Current demand for washing machines will decrease and the demand curve will shift left.",
  },
];

export default questionAnswers;
